import { render, staticRenderFns } from "./inputTag.vue?vue&type=template&id=b036038a&"
import script from "./inputTag.vue?vue&type=script&lang=js&"
export * from "./inputTag.vue?vue&type=script&lang=js&"
import style0 from "./inputTag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports